// URLのクエリパラメータ(NextのRouterのquery)からSearchRecruitment Query のinputを作成
import { RecruitmentSearchInput } from 'client/generated';
import { format, isAfter, isSameDay, isValid } from 'date-fns';

export const createRecruitmentSearchInput = (
  params: { [key: string]: string | string[] | undefined },
  currentDate: Date,
): Required<Omit<RecruitmentSearchInput, 'pagingCursor'>> => {
  // 日付の初期値はcurrentDate
  const result: Required<Omit<RecruitmentSearchInput, 'pagingCursor'>> = {
    date: format(currentDate, 'yyyy-MM-dd'),
    areaIds: null,
    licenseIds: null,
    jobBenefitIds: null,
    workingHourOptionIds: null,
    maximumWorkingHours: null,
    jobTaskIds: null,
    maximumDailyWage: null,
    minimumDailyWage: null,
    facilityFeatureIds: null,
    sortOptionId: null,
    onlyRecruiting: null,
  };

  // 日付は複数指定不可なので、dateプロパティの型が文字列のときだけ考慮する
  if ('date' in params && typeof params.date == 'string') {
    const parsedDate = new Date(params.date as string);
    // Ucareの募集検索は過去の日付で検索できないため、クエリパラメータのdateは当日もしくはそれ以降のみ許可
    if (isValid(parsedDate) && (isSameDay(parsedDate, currentDate) || isAfter(parsedDate, currentDate))) {
      result.date = params.date;
    }
  }

  if (params?.area_ids) {
    result.areaIds = [params.area_ids].flat(1);
  }

  if (params?.license_ids) {
    result.licenseIds = [params.license_ids].flat(1);
  }

  if (params?.facility_feature_ids) {
    result.facilityFeatureIds = [params.facility_feature_ids].flat(1);
  }

  if (params?.job_benefit_ids) {
    result.jobBenefitIds = [params.job_benefit_ids].flat(1);
  }

  if (params?.working_hour_option_ids) {
    result.workingHourOptionIds = [params.working_hour_option_ids].flat(1);
  }

  if (params?.sort_option_id && typeof params.sort_option_id === 'string') {
    result.sortOptionId = params.sort_option_id;
  }

  if (params?.maximum_working_hours) {
    result.maximumWorkingHours = Number([params.maximum_working_hours].flat(1)[0]);
  }

  if (params?.minimum_daily_wage) {
    result.minimumDailyWage = Number([params.minimum_daily_wage].flat(1)[0]);
  }

  if (params?.maximum_daily_wage) {
    result.maximumDailyWage = Number([params.maximum_daily_wage].flat(1)[0]);
  }

  if (params?.job_task_ids) {
    result.jobTaskIds = [params.job_task_ids].flat(1);
  }

  if (params?.only_recruiting) {
    result.onlyRecruiting = true;
  }

  return result;
};
